export const setBrowserLocation = location => {
	window.location.href = location;
};
